import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UpdatePropertyOption } from '@app/shared/interfaces';
import { Property } from '@app/shared/services/properties/properties.service';

@Component({
  standalone: false,
  selector: 'sbnb-merge-match-dropdown',
  templateUrl: './merge-match-dropdown.component.html',
  styleUrls: ['./merge-match-dropdown.component.scss'],
})
export class MergeMatchDropdownComponent implements OnInit {
  @Input() properties: Property[];
  @Input() hidePropertiesWithIds: string[];
  @Input() isMuted: boolean = false;
  @Input()
  selectedOption: UpdatePropertyOption | string = UpdatePropertyOption.CreateNewProperty;
  @Input()
  showFocusBorderIfMergeCandidate: boolean;
  @Output()
  selectedOptionChanged: EventEmitter<UpdatePropertyOption> = new EventEmitter();

  propertyEntities: {
    [id: string]: any;
  };

  searchCriteria: string;
  filteredProperties: any[];
  hasInteractedWithDropdown = false;

  UpdatePropertyOption = UpdatePropertyOption;

  constructor() { }

  ngOnInit(): void {
    this.filteredProperties = [...this.properties];
    this.convertPropertiesToEntities();
  }

  convertPropertiesToEntities() {
    if (this.properties && this.properties.length > 0) {
      this.propertyEntities = this.properties.reduce((entities: { [id: number]: Property }, record: any) => {
        return {
          ...entities,
          [record.id]: record,
        };
      }, {});
    } else {
      // No properties so update selection to Create New Property
      this.selectedOptionChange(UpdatePropertyOption.CreateNewProperty);
    }
  }

  selectedOptionChange(option) {
    this.hasInteractedWithDropdown = true;
    this.filteredProperties = [...this.properties];
    this.selectedOptionChanged.emit(option);
  }

  filterProperties(searchCriteria) {
    this.hasInteractedWithDropdown = true;

    if (!searchCriteria || searchCriteria === '') {
      this.filteredProperties = this.properties;
    }

    this.filteredProperties = this.properties.filter((prop) => {
      return (
        prop.name.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1 ||
        prop.location.apt?.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1 ||
        prop.location.street?.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1 ||
        prop.location.city?.toLowerCase().indexOf(searchCriteria.toLowerCase()) > -1
      );
    });
  }
}
